const alertContainer = document.querySelector('.block-alert-top');
import getRemBase from 'propel/getRemBase';

// Move alert-top__right content above search button on page load
const moveAlertContent = () => {
	const alertRightContent = document.querySelector(
		'.block-content.block-alert-top__right'
	);
	const searchButton = document.querySelector(
		'.block-navigation-search-button'
	);

	if (alertRightContent && searchButton) {
		// Clone the content to avoid removing it from original location
		const clonedContent = alertRightContent.cloneNode(true);
		// Add a class to identify the moved content
		clonedContent.classList.add('block-alert-top__right--moved');
		// Insert before the search button
		searchButton.parentNode.insertBefore(clonedContent, searchButton);
	}
};

// Run once on page load
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', moveAlertContent);
} else {
	// DOM is already loaded
	moveAlertContent();
}

//Add height to body for other fixed/absolute elements
if (alertContainer) {
	if (localStorage.getItem('alert-top')) {
		alertContainer.style.display = 'none';
	} else {
		alertContainer.style.display = '';
	}

	const closeButton = alertContainer.querySelector(
		'.block-alert-top__close-button .wp-block-button__link, .block-alert-top__close-button'
	);

	if (closeButton) {
		closeButton.addEventListener('click', function (e) {
			e.preventDefault();
			alertContainer.style.display = 'none';
			localStorage.setItem('alert-top', 'closed');
		});
	}

	const alertObserver = new ResizeObserver((entries) => {
		entries.forEach(() => {
			const alertContainerTop = alertContainer.offsetTop;
			const alertContainerHeight = alertContainer.offsetHeight;

			document.body.style.setProperty(
				'--alert-height',
				`${(alertContainerHeight + alertContainerTop) / getRemBase()}rem`
			);
		});
	});

	alertObserver.observe(alertContainer);
}
